import UserInfoMain from './userInfoMain';

function UserInformation() {
  return <UserInfoMain />;
}
export default UserInformation;
